import { render, staticRenderFns } from "./ShowUserGroups.vue?vue&type=template&id=738eca42&scoped=true"
import script from "./ShowUserGroups.vue?vue&type=script&lang=js"
export * from "./ShowUserGroups.vue?vue&type=script&lang=js"
import style0 from "./ShowUserGroups.vue?vue&type=style&index=0&id=738eca42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738eca42",
  null
  
)

export default component.exports